import { get, post, put, remove } from "../../api_helper";
import * as url from "../../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const createMISDataLog = (payload) => post(baseURL + url.MIS_DATA_LOG, payload);
export const getMISDataLogDetails = (id) => get(`${baseURL + url.MIS_DATA_LOG}/${id}`);
export const updateMISDataLog = (id, payload) => put(`${baseURL + url.MIS_DATA_LOG}/${id}`, payload);
export const deleteMISDataLog = (id) => remove(`${baseURL + url.MIS_DATA_LOG}/${id}`);